module.exports = __webpack_public_path__ + "static/media/glutenFree.5a75f0db.svg";